
import React from 'react';
import { Button} from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import { RenderIf, Break } from "@alanngo/custom-components/dist"

import Laptop from '../../components/Laptop';
const SingleLaptop = ({ laptops }) => {
    const { laptopId } = useParams()
    const laptop = laptops.find(elem => elem._id === laptopId)
    const history = useHistory()

    return (
        <div className='SingleLaptop' align="center">
            <RenderIf condition={laptop && laptops}>
                <Laptop laptop = {laptop} key={laptop._id}/>
            </RenderIf>
        
            <Break/>
            <Button variant="secondary" onClick={() => history.push("/laptops")}>Go Back</Button>
        </div>
    )
}

export default SingleLaptop;
